var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1125_958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.983 3.33325C10.783 3.33325 3.33301 10.7999 3.33301 19.9999C3.33301 29.1999 10.783 36.6666 19.983 36.6666C29.1997 36.6666 36.6663 29.1999 36.6663 19.9999C36.6663 10.7999 29.1997 3.33325 19.983 3.33325ZM31.533 13.3333H26.6163C26.083 11.2499 25.3163 9.24992 24.3163 7.39992C27.383 8.44992 29.933 10.5833 31.533 13.3333ZM19.9997 6.73325C21.383 8.73325 22.4663 10.9499 23.183 13.3333H16.8163C17.533 10.9499 18.6163 8.73325 19.9997 6.73325ZM7.09967 23.3333C6.83301 22.2666 6.66634 21.1499 6.66634 19.9999C6.66634 18.8499 6.83301 17.7333 7.09967 16.6666H12.733C12.5997 17.7666 12.4997 18.8666 12.4997 19.9999C12.4997 21.1333 12.5997 22.2333 12.733 23.3333H7.09967ZM8.46634 26.6666H13.383C13.9163 28.7499 14.683 30.7499 15.683 32.5999C12.6163 31.5499 10.0663 29.4333 8.46634 26.6666ZM13.383 13.3333H8.46634C10.0663 10.5666 12.6163 8.44992 15.683 7.39992C14.683 9.24992 13.9163 11.2499 13.383 13.3333ZM19.9997 33.2666C18.6163 31.2666 17.533 29.0499 16.8163 26.6666H23.183C22.4663 29.0499 21.383 31.2666 19.9997 33.2666ZM23.8997 23.3333H16.0997C15.9497 22.2333 15.833 21.1333 15.833 19.9999C15.833 18.8666 15.9497 17.7499 16.0997 16.6666H23.8997C24.0497 17.7499 24.1663 18.8666 24.1663 19.9999C24.1663 21.1333 24.0497 22.2333 23.8997 23.3333ZM24.3163 32.5999C25.3163 30.7499 26.083 28.7499 26.6163 26.6666H31.533C29.933 29.4166 27.383 31.5499 24.3163 32.5999ZM27.2663 23.3333C27.3997 22.2333 27.4997 21.1333 27.4997 19.9999C27.4997 18.8666 27.3997 17.7666 27.2663 16.6666H32.8997C33.1663 17.7333 33.333 18.8499 33.333 19.9999C33.333 21.1499 33.1663 22.2666 32.8997 23.3333H27.2663Z",
    fill: "url(#paint0_linear_1125_958)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1125_958",
    x1: 19.9997,
    y1: 3.33325,
    x2: 19.9997,
    y2: 36.6666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1125_958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalIcon);
export default __webpack_public_path__ + "static/media/globalIcon.b40153ca24c48ea7c8c947f172afe06b.svg";
export { ForwardRef as ReactComponent };